var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.609,225.48v-52.959c0-27.618-22.469-50.087-50.087-50.087h-64.609L255.962,26.478 c-6.325-5.623-15.859-5.623-22.184,0l-107.952,95.957H83.478C37.448,122.435,0,159.883,0,205.913v200.348 c0,46.03,37.448,83.478,83.478,83.478h345.043c27.618,0,50.087-22.469,50.087-50.087v-52.959 c19.433-6.892,33.391-25.45,33.391-47.215v-66.783C512,250.93,498.041,232.372,478.609,225.48z M244.87,61.294l68.783,61.141 H176.087L244.87,61.294z M445.217,439.652c0,9.206-7.49,16.696-16.696,16.696H83.478c-27.618,0-50.087-22.469-50.087-50.087 V205.913c0-27.618,22.469-50.087,50.087-50.087h345.043c9.206,0,16.696,7.49,16.696,16.696v50.087H395.13 c-46.03,0-83.478,37.448-83.478,83.478c0,46.03,37.448,83.478,83.478,83.478h50.087V439.652z M478.609,339.478 c0,9.206-7.49,16.696-16.696,16.696H395.13c-27.618,0-50.087-22.469-50.087-50.087c0-27.618,22.469-50.087,50.087-50.087h66.783 c9.206,0,16.696,7.49,16.696,16.696V339.478z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 395.13,
    cy: 306.087,
    r: 16.696
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.8d45bf2e78fcfbde80028a3de6ea0f5f.svg";
export { ForwardRef as ReactComponent };